import { createApp } from 'vue';
import App from './App.vue';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import router from './router';
import { IonicVue } from '@ionic/vue';
import { createPinia } from 'pinia';
import BButton from '@/components/BButton.vue';
import BInput from '@/components/BInput.vue';
import BRadio from '@/components/BRadio.vue';
import BVideo from '@/components/BVideo.vue';
import BStartButton from '@/components/BStartButton.vue';
import BCheckboxItem from '@/components/BCheckboxItem.vue';
import BRadioCheckbox from '@/components/BRadioCheckbox.vue';
import { setI18nInstance } from '@/helpers';

import './assets';
import { createI18n } from "vue-i18n";
import { languages } from './locale';

// Get the saved locale from localStorage or use Swedish as default
const savedLocale = localStorage.getItem('userLocale') || 'sv';
// console.log('Current locale:', savedLocale);

// Create i18n instance
const i18n = createI18n({
  locale: savedLocale,
  fallbackLocale: 'en_us',
  messages: languages
});

// Set the i18n instance in our helpers
setI18nInstance(i18n);

const pinia = createPinia();

const app = createApp(App)
  .use(IonicVue, {
    mode: 'ios',
    swipeBackEnabled: false,
  })
  .use(router)
  .use(pinia)
  .use(i18n) // Add the i18n plugin
  .component('BButton', BButton)
  .component('BInput', BInput)
  .component('BRadio', BRadio)
  .component('BRadioCheckbox', BRadioCheckbox)
  .component('BVideo', BVideo)
  .component('BStartButton', BStartButton)
  .component('BCheckboxItem', BCheckboxItem);

router.isReady().then(() => {
  app.mount('#app');
});